import { defineStore } from 'pinia'
import { sliderData } from '@/api/slider'
import { getPermission } from '@/utils/permission/permission-auth'
import { permissionList } from '@/utils/permission/permission'
import { useRouter } from 'vue-router'
// import { permissionList } from '@/utils/permission/permission'
// import router,{  dynamicRoutes } from "@/router";

export const useSliderStore = defineStore('slider', {
  state: () => {
    return {
      sliderData: [] as any[],
      sliderListData: [] as any[],
      routerData: [] as any[],
      dynamicRoutes: [] as any[],
      isCollapse: false,
      navTitle: '',
      navParTitle: ''
    }
  },
  actions: {
    async init() {
      console.log(this.sliderData)
      // const arr = permissionList.filter((item) => item.parentId == 0)
      const selfPermission = getPermission()
      const permissionMap = selfPermission.reduce((acc, obj) => {
        if (obj && !acc.get(obj)) {
          acc.set(obj, obj)
        }
        return acc
      }, new Map())
      // const asyncRoutes = filterDynamicRoutes(selfPermission,dynamicRoutes);
      // asyncRoutes.forEach((route) => {
      //     router.addRoute(route);
      // });
      const arr: any[] = []
      // debugger
      // sliderData 原数据
      this.sliderListData.forEach((item) => {
        if (
          permissionMap.get(item.permission) &&
          item.permission == permissionMap.get(item.permission)
        ) {
          arr.push(item)
        }
      })

      this.sliderData = arr.sort((a, b) => a.index - b.index)
    },
    setIsCollapse(isCollapse: any) {
      this.isCollapse = isCollapse
    },
    setNavTitle(title: any) {
      this.navTitle = title
    },
    setNavParTitle(title: any) {
      this.navParTitle = title
    },
    activeItem(index: string) {
      if (this.sliderData && this.sliderData.length > 0) {
        this.sliderData.forEach((item) => {
          if (item.path == index && !item.children) {
            item.isActive = true
          } else {
            item.isActive = false
          }
        })
      }
    },
    cleanData() {
      this.sliderData = []
    },
    setRouterList(data: any) {
      this.routerData = data
    },
    setRoutes(newRoutes: any) {
      this.dynamicRoutes = newRoutes
      this.routerData = newRoutes
      const router = useRouter()
      newRoutes.forEach((route: any) => {
        router?.addRoute(route)
      })
    },
    setSliderData() {
      // console.log(this.routerData, 'routerData')
      // this.routerData.forEach((i, index) => {
      //   let isActive = false
      //   if (index == 0) {
      //     isActive = true
      //   }
      //   this.sliderListData.push({
      //     icon: i.meta.icon,
      //     name: i.meta.title,
      //     path: i.path,
      //     permission: i.meta.perms,
      //     isActive: isActive,
      //     children: i.children
      //   })
      // })
      // console.log(this.sliderListData, 'sliderListData')
      const fieldMapping = {
        // info: ['description', null], // 顶层字段
        icon: ['icon', 'meta'],
        name: ['languageKey', 'meta'],
        permission: ['perms', 'meta'],
        path: ['path', null],
        hidden: ['hidden', 'meta'],
        children: ['children', null]
      }
      let result = this.addMultipleFields(this.routerData, fieldMapping)
      const updatedTreeData = this.addFieldToEachNode(result, 'isActive', this.valueGenerator)
      console.log(updatedTreeData, 'updatedTreeData addMultipleFieldsWithExistingValues')
      this.sliderListData = updatedTreeData
      this.init()
      // this.sliderData = this.sliderListData
    },
    addMultipleFields(data: any, fieldMappings: any) {
      return data.map((item: any) => {
        // 创建一个新对象，包括原有字段
        const newItem = { ...item }

        // 遍历字段映射，添加多个新字段
        for (const [newFieldName, [sourceField, nestedObject]] of Object.entries(fieldMappings)) {
          // 如果是顶层字段
          if (nestedObject === null) {
            if (newItem[sourceField] !== undefined) {
              newItem[newFieldName] = newItem[sourceField]
            }
          } else {
            // 如果是嵌套字段
            if (newItem[nestedObject] && newItem[nestedObject][sourceField] !== undefined) {
              newItem[newFieldName] = newItem[nestedObject][sourceField]
            }
          }
        }

        // 如果有子节点，递归处理
        if (newItem.children && Array.isArray(newItem.children)) {
          newItem.children = this.addMultipleFields(newItem.children, fieldMappings)
        }

        return newItem
      })
    },
    addFieldToEachNode(data: any, newFieldName: any, valueGenerator: any) {
      return data.map((item: any, index: number) => {
        // 创建一个新对象，包括原有字段
        const newItem = { ...item }

        // 根据传入的值生成函数添加新字段
        newItem[newFieldName] = this.valueGenerator(item, index)

        // 如果有子节点，递归处理
        if (newItem.children && Array.isArray(newItem.children)) {
          newItem.children = this.addFieldToEachNode(newItem.children, newFieldName, valueGenerator)
        }

        return newItem
      })
    },
    valueGenerator(item: any, index: number) {
      // 这里可以自定义生成逻辑，例如拼接字符串
      let isActive = false
      if (item.children && Array.isArray(item.children)) {
        isActive = false
      } else {
        if (index == 0) {
          isActive = true
        }
      }
      return isActive
    }
  },
  //持久化
  persist: {
    storage: sessionStorage
  }
})
export function filterDynamicRoutes(permission: [], routes: any) {
  const res: any[] = []
  routes.forEach((route: any) => {
    if (route.meta.authName) {
      if (permission.indexOf(route.meta.authName)) {
        res.push(route)
      }
    }
  })
  return res
}
